module.exports = __webpack_public_path__ + "static/media/italic.5323d270.svg";